import styled from 'styled-components';
import { Text } from 'components/Text';
import { palette } from '@m12s/component-library';

export const CenteredMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  gap: 1.5rem;
  background-color: ${palette.Grey200};
`;

export const CenteredMessageContent = styled.div`
  max-width: 20rem;
  text-align: center;
  display: grid;
  place-items: center;
  gap: 1.25rem;
`;

export const CenteredMessageTitleText = styled(Text)`
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.5rem;
  color: ${palette.Grey700};
`;
